import { createSelector } from 'utils/app.util';

export const getWellboreFilesFromState = createSelector(
  (state) => state.getIn(['entity', 'wellboreFile']),
  (wellboreFiles) => wellboreFiles,
);
